import { Options, Prop, Vue } from 'vue-property-decorator';
import ConfirmDialogue from '@/shared/components/confirm-dialogue/index.vue';
import InputTextNumberCurrency from '../../input-text-number-currency/index.vue';
import Popover from '@/shared/components/popover/index.vue';
import CurrencyInput from '@/shared/components/currency-input/index.vue';
import store from '@/trust-atcs-app/store';
import AddBankModal from '../add-bank-modal/index.vue';
import { EventEmitter } from 'events';
import RadioButtonHorizontal from '../../radiobutton-horizontal/index.vue';
import { QuestionType } from '../../question-type';

@Options({
  components: {
    ConfirmDialogue,
    InputTextNumberCurrency,
    Popover,
    CurrencyInput,
    AddBankModal,
    RadioButtonHorizontal,
  },
})
export default class BankCardV2 extends Vue {
  @Prop()
  private bank!: any;

  @Prop()
  private formType!: string;

  private showNewBankModal = false;

  private ignoreReasonForVariance = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private newWording(wording: string): any {
    let newWording = wording;
    if (wording !== null) {
      const pattern = /--{{.*?}}--/g;
      newWording = wording.replace(pattern, '');
    }
    return newWording;
  }

  private popoverObj(wording: string): any {
    const content = store.getters.getPopovers;
    const pattern = /--\{\{(.*?)\}\}--/;
    const popovers = wording.match(pattern);
    if (popovers && popovers.length > 1) {
      const extractedContent = popovers[1];
      return content.filter((x: any) => x.key == extractedContent)[0];
    }
    return null;
  }

  private removeBankAccount(): void {
    const _confirm: any = this.$refs.confirmRemoveBankDialogue;
    _confirm
      .show({
        title: 'Remove Bank Account',
        message: 'Are you sure you want to remove this Bank Account?',
        okButton: 'Remove',
        cancelButton: 'Cancel',
      })
      .then((res: any) => {
        if (res) {
          this.$emit('removeBankAccount');
        }
      });
  }

  mounted(): void {
    this.validFormEachBank();
  }

  private validFormBank() {
    this.validFormEachBank();
  }

  private calculateValue(developerKey: string): string {
    let groupValue = 0;
    if (this.formType == 'EER') {
      if (developerKey.endsWith('ComputeGroupA-PlusMinus')) {
        groupValue = this.sumOfGroupLinedQuestions('GroupA');
      } else if (developerKey.endsWith('ComputeGroupB-PlusMinus')) {
        groupValue = this.sumOfGroupLinedQuestions('GroupB');
      } else if (developerKey.startsWith('ComputeGroupC-MaxAbsoluteDiff')) {
        groupValue = this.maxAbsDiff();
      }
      return this.formatNumberToCurrencyWithZero(groupValue);
    } else {
      if (developerKey.endsWith('ComputeGroupA-PlusMinus')) {
        groupValue = this.sumOfGroup('GroupA');
      } else if (developerKey.endsWith('ComputeGroupB-PlusMinus')) {
        groupValue = this.sumOfGroup('GroupB');
      } else if (developerKey.startsWith('ComputeGroupC-MaxAbsoluteDiff')) {
        groupValue = this.maxAbsDiff();
        const textarea = this.bank.atcsSubQuestions.find(
          (x: any) => x.atcsQuestionTypeId == QuestionType.TextAreaConditional,
        );
        // check groupValue round to 2 decimal places
        groupValue = Math.round(groupValue * 100) / 100;
        if (groupValue == 0) {
          // Set the textarea to null and disable it
          textarea.responses[0].answerTxt = null;
          textarea.responses[0].ignoreReasonForVariance = true;
          this.ignoreReasonForVariance = true;
        } else {
          // Enable the textarea
          textarea.responses[0].ignoreReasonForVariance = false;
          this.ignoreReasonForVariance = false;
        }
      }
      return this.formatNumberToCurrency(groupValue);
    }
  }

  private sumOfGroup(groupName: string): number {
    let sum = 0;
    for (let i = 0; i < this.bank.atcsSubQuestions.length; i++) {
      if (this.bank.atcsSubQuestions[i].developerKey.indexOf(groupName) == 0) {
        let operator = 1;
        if (
          this.bank.atcsSubQuestions[i].developerKey.indexOf('Minus') > 0 &&
          this.bank.atcsSubQuestions[i].developerKey.indexOf('GroupC') !== 0
        ) {
          operator = -1;
        }
        const value = this.bank.atcsSubQuestions[i].responses[0].answerCurrency || 0;
        sum += value * operator;
      }
    }
    return sum;
  }

  private sumOfGroupLinedQuestions(groupName: string): number {
    let sum = 0;
    for (let i = 0; i < this.bank.atcsSubQuestions.length; i++) {
      if (this.bank.atcsSubQuestions[i].linkedSubQuestion?.developerKey.indexOf(groupName) == 0) {
        let operator = 1;
        if (
          this.bank.atcsSubQuestions[i].linkedSubQuestion.developerKey.indexOf('Minus') > 0 &&
          this.bank.atcsSubQuestions[i].linkedSubQuestion.developerKey.indexOf('GroupC') !== 0
        ) {
          operator = -1;
        }
        const value = this.bank.atcsSubQuestions[i].linkedSubQuestion.responses[0].answerCurrency || 0;
        sum += value * operator;
      }
    }
    return sum;
  }

  private maxAbsDiff(): number {
    const groupC = {} as any;
    if (this.formType == 'EER') {
      groupC[0] = this.sumOfGroupLinedQuestions('GroupA');
      groupC[1] = this.sumOfGroupLinedQuestions('GroupB');
      groupC[2] = this.sumOfGroupLinedQuestions('GroupC');
    } else {
      groupC[0] = this.sumOfGroup('GroupA');
      groupC[1] = this.sumOfGroup('GroupB');
      groupC[2] = this.sumOfGroup('GroupC');
    }
    // console.log(this.bank.id, groupC);
    const keys = Object.keys(groupC);
    let maxDiff = 0;
    for (let i = 0; i < keys.length - 1; i++) {
      for (let j = i + 1; j < keys.length; j++) {
        const diff = Math.abs(groupC[keys[i]] - groupC[keys[j]]);
        if (diff > maxDiff) {
          maxDiff = diff;
        }
      }
    }
    return maxDiff;
  }

  private selectedBank: any = {};

  private editBankAccount(): void {
    // save the current section without reloading the page
    this.eventCtrl.emit('save-section', false, true, true);
    this.selectedBank = { ...this.bank };
    this.showNewBankModal = true;
  }

  private getResponse(linkedSubQuestion: any): string {
    const questionType = linkedSubQuestion.atcsQuestionTypeId;
    let returnValue = '';
    switch (questionType) {
      case QuestionType.Currency:
        returnValue = this.formatNumberToCurrencyWithZero(linkedSubQuestion.responses[0].answerCurrency);
        break;
      case QuestionType.Number:
        returnValue = linkedSubQuestion.responses[0].answerNumber;
        break;
      case QuestionType.ComputedCurrency:
        returnValue = this.calculateValue(linkedSubQuestion.developerKey);
        break;
      case QuestionType.TextArea:
      case QuestionType.TextAreaConditional:
        returnValue = linkedSubQuestion.responses[0].answerTxt;
        break;
    }

    return returnValue;
  }

  // Format number to currency with 2 decimal places with commas no dollar sign
  private formatNumberToCurrency(amount: number): string {
    // format number 1234567.20 to 1,234,567.20
    if (amount != null) {
      return amount.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      return '0.00';
    }
  }

  // Format number to currency with 2 decimal places with commas and dollar sign
  private formatNumberToCurrencyWithZero(amount: number): string {
    // format number 1234567.20 to $1,234,567.20
    if (amount != null) {
      return amount.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      return '$0.00';
    }
  }

  private validFormEachBank(): boolean {
    const bank = this.bank;
    let eachBankValid = true;
    for (let i = 0; i < bank.atcsSubQuestions.length; i++) {
      const answerCurrency = bank.atcsSubQuestions[i].responses[0]?.answerCurrency;
      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == 5 && answerCurrency == null) {
        eachBankValid = false;
        break;
      }
      const answerTxt = bank.atcsSubQuestions[i].responses[0]?.answerTxt;
      if (
        bank.atcsSubQuestions[i].atcsQuestionTypeId == QuestionType.TextAreaConditional &&
        (answerTxt == null || answerTxt == '') &&
        !this.ignoreReasonForVariance
      ) {
        eachBankValid = false;
        break;
      }
      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == 2 && (answerTxt == null || answerTxt == '')) {
        eachBankValid = false;
        break;
      }
      const answerNumber = bank.atcsSubQuestions[i].responses[0]?.answerNumber;
      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == 3 && (answerNumber == null || answerNumber < 0)) {
        eachBankValid = false;
        break;
      }

      if (bank.atcsSubQuestions[i].atcsQuestionTypeId == 10) {
        // Get all radio responses if not null
        const responses = bank.atcsSubQuestions[i].responses.filter((x: any) => x.answerIsSelected != null);
        if (responses.length == 0) {
          eachBankValid = false;
          break;
        }
      }
    }
    this.$emit('validFormBank');
    return eachBankValid;
  }

  get QuestionType(): any {
    return QuestionType;
  }
}
